// Module
var code = "<main data-app>\n  <topbar />\n  <router-view></router-view>\n</main>\n";
// Exports
export default code;